<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()" v-if="permissions && permissions['managers.write'] === true">Nuevo Gerente</CButton>
          <CButton color="success" size="sm" @click="importModal()" v-if="permissions && permissions['managers.write'] === true">Importar Gerentes</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :tableFilter="tableFilter"
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="30"
        :dark="dark"
        pagination
        class="executives_table"
      >
        <template #position="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.position }}</td>
        </template>
        <template #code="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.code}}</td></template>
        <template #name="{item}"><td style="font-size: 12px;">{{item.name}}</td></template>
        <template #wallet="{item}">
          <td class="text-center" style="font-size: 12px;">
            {{(item.wallet)? item.wallet : '-'}}
          </td>
        </template>
        <template #stock="{item}">
          <td class="text-center" style="font-size: 12px;">{{(item.stock)? item.stock : '-'}}</td></template>
        <template #user="{item}">
          <td class="text-center w200" style="font-size: 12px;">
            {{item.user && item.user.api_token ? item.user.email : '-'}}
            <span v-if="item.user && item.user.api_token">
              <br />
              {{item.user.last_login | date}}
              <span v-if="permissions && permissions['executives.login'] === true">                
                <br />
                <CButton color="success" size="sm" @click="login(item)">
                  <CIcon name="cil-https"/> Ingresar
                </CButton>
              </span>
            </span>
          </td>
        </template>
        <template #actions="{item}">
          <td class="table_actions b3">
            <span v-if="!permissions || permissions['managers.write'] !== true">-</span>
            <CButton color="warning" size="sm" @click="updateModal(item)" v-if="permissions && permissions['managers.write'] === true"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)" v-if="permissions && permissions['managers.write'] === true"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <ExecutiveModal ref="executiveModal" @store="storeProcess" @update="updateProcess"></ExecutiveModal>
    <DowngradeModal ref="downgradeModal" @downgrade="downgradeProcess"></DowngradeModal>
    <ImportExecutivesModal ref="importModal" @import="importProcess"></ImportExecutivesModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import ExecutiveModal from './ExecutiveModal.vue'
import DowngradeModal from './DowngradeModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ImportExecutivesModal from './ImportExecutivesModal.vue'
import ws from '../../services/executives';
import store from '../../store'
import router from '../../router/index'
  
export default {
  name: 'ExecutivesTable',
  components: { ExecutiveModal, DeleteModal, DowngradeModal, ImportExecutivesModal },
  props: {
    items: Array,
    permissions: Object,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: '#', _style: 'font-size: 12px; width: 50px;'},
          {key: 'code', label: 'Ruta', _style: 'font-size: 12px; width: 80px;'},
          {key: 'name', label: 'Nombre', _style: 'font-size: 12px;'},
          {key: 'wallet', label: 'Monedero', _style: 'font-size: 12px; width: 100px;'},
          {key: 'stock', label: 'Stock', _style: 'font-size: 12px; width: 100px;'},
          {key: 'user', label: 'Acceso', _style: 'font-size: 12px;'},
          {key: 'actions', label: 'Acciones', class: 'actions', _style: 'font-size: 12px;' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      executive_id: 0,
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  methods: {
    login(item) {
      if (!item.user || !item.user.api_token) {
        this.showToast('warning', 'Este gerente no tiene usuario asignado.');
        return;
      }

      this.$router.push({
        name: 'LoginLink',
        params: {
          code: item.user.api_token
        }
      });
    },
    storeModal () {
      this.$refs.executiveModal.storeModal();
    },
    updateModal (item) {
      this.$refs.executiveModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Gerente", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    downgradeModal (executive_id) {
      this.$refs.downgradeModal.downgradeModal(executive_id);
    },
    async downgradeProcess(data) {
      let response = await ws.downgrade(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    importModal () {
      this.$refs.importModal.importModal();
    },
    async importProcess(data) {
      this.$emit("refresh", data );
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>
<style>
.executives_table td{
  font-size: 12px;  
  padding: 5px 8px !important;
}
</style>